module.exports = __webpack_public_path__ + "c3b34d59ef4c949d25a4f32b5096471a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-bold/opensans-bold.ttf
// module id = ./src/styles/fonts/opensans-bold/opensans-bold.ttf
// module chunks = index